export default __webpack_public_path__ + "static/media/wallet.566948f0.svg";